export const zIndex = {
  header: 9,
  banner: 9,
  modal: 100,
};

export default zIndex;
